import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M10 15c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zM6.87 4c.93 0 1.74.65 1.95 1.56L10.74 14H10c-2.21 0-4 1.79-4 4v1H0v-2h4.09c.38-2.27 2.03-4.1 4.19-4.75h.01L6.87 6H4c-.55 0-1-.45-1-1l.0068-.1162C3.0648 4.388 3.4893 4 4 4zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4.96-14c.84 0 1.59.52 1.88 1.31L18.19 8h.56c2.38 0 4.59 1.57 5.12 3.89.76 3.27-1.96 6.25-5.12 6.1-2.34-.11-4.21-1.76-4.65-3.99h-2.33l-.46-2h2.79c.15-.75.47-1.42.9-2h-4.14l-.46-2h5.66l-1.1-3H12c-.55 0-1-.45-1-1l.0068-.1162C11.0648 3.388 11.4893 3 12 3zm4.1456 7.0007L18.93 10l-.01.01.63 1.73c.19.52-.08 1.09-.6 1.28l-.112.0338c-.4875.1164-.9916-.151-1.168-.6338l-.62-1.7c-.66.56-1.07 1.4-1.05 2.36.04 1.55 1.34 2.86 2.88 2.92 1.74.06 3.12-1.28 3.12-3 0-1.71-1.36-3.04-3.07-3z",
    fillRule: "evenodd"
  }],
  circles: []
};
var BikeScooterIcon = function BikeScooterIcon(props) {
  return renderIcon(props, iconType);
};
export { BikeScooterIcon };